<template>
  <div class="newhomepage-header" id="collapsestyle">
    <img v-if="deviceType=='手机'"
      src="@/assets/image/mobile/newhomepage/caidan.png"
      alt=""
      class="header-img"
      @touchend="topmenu"
     
    />
    <img v-else
      src="@/assets/image/mobile/newhomepage/caidan.png"
      alt=""
      class="header-img"
     
      @click="topmenu"
    />

    <img
      src="@/assets/image/mobile/newhomepage/logo.png"
      alt=""
      class="header-imginfo"
    />
    <div class="header-title" id="navfree" @touchend="navfreefn" @click="navfreefn">免费试用
      <div class="navfree-mask" v-show="isfree">
              <!-- <span class="close-style" @click="closenavfreefn">x</span> -->

              <div class="mask-content">
                <img
                  src="@/assets/image/homePage/mainbottom/weixinimg.png"
                  alt=""
                />
                <span>添加上方微信客服可开通产品免费试用</span>
              </div>
            </div></div>
         
    <div class="collapse-style" v-if="ismenu" >
      <div class="collapse-home collapse-hometop">
        <router-link to="/home" class="hometop-info">&nbsp;&nbsp;首页 </router-link>
        <svg
        @click="closemenu"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1024 1024"
          data-v-ea893728=""
        >
          <path
            fill="currentColor"
            d="M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
          ></path>
        </svg>
      </div>

      <div class="collapse-home">
        <router-link to="/product" class="hometop-allinfo">
          &nbsp;&nbsp;产品介绍 
        </router-link>
      </div>
 
      <el-collapse accordion class="collapse-main">
        <el-collapse-item >
          <template  #title>
            <span class="collapse-title">
              &nbsp;&nbsp;业务介绍
            </span>
 
    </template>
          <div class="collapse-content">
            <router-link to="/moneyinvolved">
              <span class="olmian-style"> &nbsp;&nbsp;&nbsp;&nbsp;案件配侦 </span>
            </router-link>
          </div>
          <div class="collapse-content">
            <router-link to="/dataasset">
              <span class="olmian-style">&nbsp;&nbsp;&nbsp;&nbsp;资产挽损</span>
            </router-link>
          </div>
          <div class="collapse-content">
            <router-link to="/serviceprocess">
                <span class="olmian-style">&nbsp;&nbsp;&nbsp;&nbsp;安全审计</span>
              </router-link>
          </div>
          <div class="collapse-content">
            <router-link to="/onchainatm">
                <span class="olmian-style">&nbsp;&nbsp;&nbsp;&nbsp;链上AML</span>
              </router-link>
          </div>
          <div class="collapse-content">
            <router-link to="/businessintroduce">
                <span class="olmian-style">&nbsp;&nbsp;&nbsp;&nbsp;合规处置</span>
              </router-link>
          </div>
        </el-collapse-item>
       
      </el-collapse>
      <div class="collapse-home">
        <router-link to="/security" class="hometop-allinfo">
          &nbsp;&nbsp;图链安全
        </router-link>
      </div>
      <div class="collapse-home">
        <router-link to="/aboutus" class="hometop-allinfo">&nbsp;&nbsp;关于我们 </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ismenu: false,
      isfree: false,
      deviceType: this.getDeviceType(),
    };
  },
  methods: {
    topmenu() {
      this.ismenu=!this.ismenu
    },
    closemenu(){
      this.ismenu=false
    },
    navfreefn() {
      this.isfree = true;
    },
    closenavfreefn() {
      console.log(11);
      console.log(this.isfree);
      setTimeout(() => {
        this.isfree = !this.isfree;
      }, 100);
    },
    getDeviceType() {
      return window.innerWidth < 768 ? '手机' : '电脑';
    },
    handleResize() {
      this.deviceType = this.getDeviceType();
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    document.addEventListener("click", (e) => {
      const navfree = document.getElementById("navfree");

      if (navfree) {
        if (!navfree.contains(e.target)) {
          this.isfree = false;
        }
      }
    });
    document.addEventListener("click", (e) => {
      const collapse = document.getElementById("collapsestyle");

      if (collapse) {
        if (!collapse.contains(e.target)) {
          this.ismenu = false;
        }
      }
    });
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/toppage.scss";
</style>
